(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bioluxea-sales-cart"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '.blx-sales-cart';
  const root = document.querySelector(selector);
  if (!root || root.dataset.enhanced) return;
  root.dataset.enhanced = 'true';
  let busy = false;
  let timer;
  const english = root.dataset.cartLanguage === 'en';
  const words = english ? {
    saving: 'Updating cart…', saved: 'Cart updated.', removed: 'Item removed.',
    failed: 'The change could not be confirmed. Check your cart and try again.',
    unavailable: 'This quantity is not available. Choose a smaller quantity.',
    invalid: 'Enter a whole number of 1 or more.'
  } : {
    saving: 'Winkelwagen bijwerken…', saved: 'Winkelwagen bijgewerkt.', removed: 'Artikel verwijderd.',
    failed: 'De wijziging kon niet worden bevestigd. Controleer je winkelwagen en probeer opnieuw.',
    unavailable: 'Dit aantal is niet beschikbaar. Kies een kleiner aantal.',
    invalid: 'Vul een heel aantal van 1 of meer in.'
  };
  const enhance = () => {
    root.classList.add('blx-cart-enhanced');
    root.querySelectorAll('[data-cart-step]').forEach(button => { button.hidden = false; });
  };
  const status = message => { root.querySelector('.blx-cart-feedback').textContent = message; };
  const checkout = disabled => {
    const button = root.querySelector('[name="checkout"]');
    if (button) button.disabled = disabled;
  };
  const valid = input => {
    input.setCustomValidity('');
    const number = Number(input.value);
    if (!input.value.trim() || !Number.isSafeInteger(number) || number < 1) {
      status('');
      input.setCustomValidity(words.invalid);
      input.reportValidity();
      return false;
    }
    return true;
  };
  const refresh = async () => {
    const response = await fetch(root.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000), headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('cart-readback');
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const updated = parsed.querySelector(selector);
    if (!updated) throw new Error('cart-markup');
    root.innerHTML = updated.innerHTML;
    root.dataset.cartItemCount = updated.dataset.cartItemCount;
    document.dispatchEvent(new CustomEvent('blx:cart-updated', { detail: { itemCount: Number(updated.dataset.cartItemCount) } }));
    enhance();
  };
  const change = async (line, quantity, control) => {
    if (busy) return;
    clearTimeout(timer);
    busy = true;
    const index = [...root.querySelectorAll('[data-line-key]')].indexOf(line);
    const key = line.dataset.lineKey;
    root.setAttribute('aria-busy', 'true');
    root.querySelector('.blx-cart-error').hidden = true;
    root.querySelectorAll('button, input').forEach(element => { element.disabled = true; });
    root.querySelectorAll('.blx-cart-remove').forEach(link => { link.setAttribute('aria-disabled', 'true'); });
    status(words.saving);
    let message = quantity === 0 ? words.removed : words.saved;
    let error = '';
    let confirmed = false;
    try {
      const response = await fetch(root.dataset.cartUrl + '/change.js', {
        method: 'POST', credentials: 'same-origin', signal: AbortSignal.timeout(15000),
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!response.ok) error = response.status === 422 ? words.unavailable : words.failed;
      await refresh();
      confirmed = true;
      const saved = [...root.querySelectorAll('[data-line-key]')].find(item => item.dataset.lineKey === key);
      if (saved && Number(saved.querySelector('input').value) !== quantity) error = words.unavailable;
    } catch {
      error = words.failed;
      try { await refresh(); confirmed = true; } catch { root.querySelector('.blx-cart-reload').hidden = false; }
    } finally {
      busy = false;
      root.removeAttribute('aria-busy');
      status('');
      if (error) {
        const alert = root.querySelector('.blx-cart-error');
        alert.textContent = error;
        alert.hidden = false;
      } else {
        requestAnimationFrame(() => status(message));
      }
      if (confirmed) {
        const lines = [...root.querySelectorAll('[data-line-key]')];
        const targetLine = lines.find(item => item.dataset.lineKey === key) || lines[Math.min(index, lines.length - 1)];
        const target = targetLine && targetLine.querySelector(control);
        (target && !target.disabled ? target : targetLine?.querySelector('input') || root.querySelector('h1')).focus({ preventScroll: true });
      }
    }
  };
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-step], .blx-cart-remove');
    if (!button) return;
    event.preventDefault();
    if (busy) return;
    const line = button.closest('[data-line-key]');
    const input = line.querySelector('input');
    if (button.matches('.blx-cart-remove')) { change(line, 0, '.blx-cart-remove'); return; }
    input.setCustomValidity('');
    const quantity = Math.max(1, Number(input.dataset.savedQuantity) + Number(button.dataset.cartStep));
    change(line, quantity, '[data-cart-step="' + button.dataset.cartStep + '"]');
  });
  root.addEventListener('input', event => {
    if (!event.target.matches('input[name="updates[]"]') || busy) return;
    clearTimeout(timer);
    event.target.setCustomValidity('');
    checkout(true);
    status(words.saving);
    timer = setTimeout(() => {
      if (valid(event.target)) change(event.target.closest('[data-line-key]'), Number(event.target.value), 'input');
    }, 650);
  });
  root.addEventListener('change', event => {
    if (!event.target.matches('input[name="updates[]"]') || busy) return;
    if (valid(event.target)) change(event.target.closest('[data-line-key]'), Number(event.target.value), 'input');
  });
  root.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout' && !busy) return;
    event.preventDefault();
    if (busy) return;
    const input = root.querySelector('input[name="updates[]"]:focus') || root.querySelector('input[name="updates[]"]');
    if (input && valid(input)) change(input.closest('[data-line-key]'), Number(input.value), 'input');
  });
  enhance();
})();
  } catch(e) { console.error(e); }
})();

})();
